import { render, staticRenderFns } from "./OrderItemReport.vue?vue&type=template&id=5a1395dd&scoped=true&"
import script from "./OrderItemReport.vue?vue&type=script&lang=js&"
export * from "./OrderItemReport.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemReport.vue?vue&type=style&index=0&id=5a1395dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1395dd",
  null
  
)

export default component.exports